<template>
    <div class="library-commented-on-by-filter" data-testid="library-commented-on-by-filter">
        <CollapsibleWidget>
            <template #name>Comments</template>

            <RadioGroup v-model="creativeLibraryFiltersStore.commentedOnBy">
                <Radio v-for="filter in BannerQaCommentedOnByFilter" :key="filter" :label="filter">
                    {{ BannerQaCommentedOnByFilterLabel[filter] }}
                </Radio>
            </RadioGroup>
        </CollapsibleWidget>
    </div>
</template>

<script lang="ts" setup>
import CollapsibleWidget from "@/components/Campaign/widgets/CollapsibleWidget.vue";
import { BannerQaCommentedOnByFilter, BannerQaCommentedOnByFilterLabel } from "@/enums/filters";
import { useCreativeLibraryFiltersStore } from "@/store/pinia/creativeLibraryFilters";

const creativeLibraryFiltersStore = useCreativeLibraryFiltersStore();
</script>

<style lang="scss">
@use "@style/variables" as *;

.library-commented-on-by-filter {
    .ivu-radio {
        margin: 0;
    }

    .ivu-radio-group {
        display: block;
    }

    .ivu-radio-wrapper {
        margin: 0;
        padding: 0 0 0 50px;
        display: block;
    }
}
</style>
